// extracted by css-extract-rspack-plugin
export default {"editButton":"PlaygroundJSONViewModeToolbar-module__editButton__nEl7m","iconButton":"PlaygroundJSONViewModeToolbar-module__iconButton__rlyQk"};